import React, { Component } from "react";
import { NavPageWrapper } from "../../common/Nav";
import { PageLastLoaded } from "../../common/PageLastLoaded";
import { default as AgentTimeOff } from "./AgentTimeOff";
import { default as SupervisorTimeOff } from "./SupervisorTimeOff";
import * as actions from '../redux/time_off_actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Route } from "react-router-dom";
import { default as Login } from "../../login/Login";

export class TimeOff extends Component {
    constructor(props) {
        super(props);
        
        if(this.props.actions.fetchTimeOffEnumAction) {
			this.props.actions.fetchTimeOffEnumAction();
        }

        if(this.props.actions.fetchRequestStatusEnumAction) {
			this.props.actions.fetchRequestStatusEnumAction();
        }

        if(this.props.actions.fetchNotificationTypeEnumAction) {
			this.props.actions.fetchNotificationTypeEnumAction();
        }
    }

    render() {
        let { TabType } = this.props.match.params;
        let { User, position } = this.props;
    
        return (
            <NavPageWrapper currPath={this.props.match.path}>
                <PageLastLoaded />
                { 
                    User.isTimeOffVisible === true ?
                        User.position === position.agent 
                        ? <AgentTimeOff />
                        : <SupervisorTimeOff TabType={TabType} ManagementUnitID={this.props.location.managementUnitID} />
                    : <Route component={Login} />
                }
            </NavPageWrapper>
        );
    }
}

function mapStateToProps(state) {
	return {
        User: state.common.user,
        position: state.common.position,
        TimeOffEnumItems: state.timeoff.TimeOffEnumItems
    };
}

function mapDispatchToProps(dispatch) {
	return {
        actions: bindActionCreators({ ...actions }, dispatch)
	};
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(TimeOff);


// WEBPACK FOOTER //
// ./src/features/timeoff/TimeOff/TimeOff.js